import { WindowObject } from '@btcdirect/functions';
import { useLogger } from '@btcdirect/shared/src/composables/util/logger';
import { InstanceParameters, MethodParameters } from '@btcdirect/shared/src/types';
import { Instance, InstanceConfiguration } from '../types';
import { CallableMethods } from './types';

const { debug, warn } = useLogger();

/**
 * Process the method calls in the queue and replace the window object with the sync method call afterwards
 */
export function processQueue(instance: Instance, instanceParameters: InstanceParameters, callableMethods: CallableMethods, windowObject: WindowObject): void {
    for (const method of instance.queue) {
        const [methodName, methodParameters] = method;
        callMethod(methodName, methodParameters, instanceParameters, instance.config, callableMethods);
    }

    // Once we've finished processing all async calls, we're going to convert the LoaderObject into sync calls to methods
    synchronizeQueue(instance, instanceParameters, callableMethods, windowObject);
}

/**
 * Replace the object with the method queue with a method to handle any further calls
 */
function synchronizeQueue(instance: Instance, instanceParameters: InstanceParameters, callableMethods: CallableMethods, windowObject: WindowObject): void {
    windowObject[instance.name] = (methodName: string, methodParameters: MethodParameters) => {
        callMethod(methodName, methodParameters, instanceParameters, instance.config, callableMethods);
    };
}

/**
 * Call a method from the registry if it's in the list
 */
function callMethod(
    methodName: string,
    methodParameters: MethodParameters,
    instanceParameters: InstanceParameters,
    instanceConfiguration: InstanceConfiguration,
    callableMethods: CallableMethods
) {
    if (!(methodName in callableMethods)) {
        warn(`Tried to call method "${methodName}" which is not available for this widget`);
        return;
    }

    !!methodParameters
        ? debug(`Called method "${methodName}"`, 'Provided parameters: ' + JSON.stringify(methodParameters))
        : debug(`Called method "${methodName}"`);

    // Actually call the method defined in the registry
    callableMethods[methodName](methodParameters, instanceParameters, instanceConfiguration);
}
